import { gql } from "apollo-boost";

export const CREATE_DESIGN = gql`
  mutation CREATE_DESIGN($name: String!, $date: DateTime, $id_article: Int!) {
    createDesign(name: $name, description: $name, date: $date, id_article: $id_article)
  }
`;

export const UPDATE_DESIGN = gql`
  mutation UPDATE_DESIGN($id_design: Int!, $name: String!, $id_article: Int!) {
    updateDesign(id_design: $id_design, name: $name, id_article: $id_article)
  }
`;

export const DELETE_DESIGN = gql`
  mutation DELETE_DESIGN($id_design: Int!) {
    deleteDesign(id_design: $id_design)
  }
`;

export const CREATE_VALUE_DESIGN = gql`
  mutation CREATE_VALUE_DESIGN($id_variable: Int!, $id_design: Int!, $value: String) {
    createValueDesign(id_variable: $id_variable, id_design: $id_design, value: $value)
  }
`;

export const UPDATE_VALUE_DESIGN = gql`
  mutation UPDATE_VALUE_DESIGN($id_variable: Int!, $id_design: Int!, $value: String) {
    updateValueDesign(id_variable: $id_variable, id_design: $id_design, value: $value)
  }
`;

export const DELETE_VALUE_DESIGN = gql`
  mutation DELETE_VALUE_DESIGN($id_variable: Int!, $id_design: Int!) {
    deleteValueDesign(id_variable: $id_variable, id_design: $id_design)
  }
`;
